import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { Fade } from "react-awesome-reveal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "elements/Button";

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send("service_zcwsbym", "template_u1lzawn", formData, "ddWh2pAB2XmyXzuQN")
      .then(() => {
        setSubmitted(true);
        toast.success("Bedankt voor je bericht! We nemen zo snel mogelijk contact met je op.");
        setFormData({
          name: "",
          company: "",
          email: "",
          phone: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        toast.error(`Er is een fout opgetreden: ${error.message}`);
      });
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gray-100 px-6">
      <div className="w-full max-w-3xl bg-white p-8 rounded-lg shadow-lg">
        <Fade direction="down" triggerOnce>
          <h1 className="text-4xl text-center font-bold text-theme-blue mb-6">
            Samenwerken met ons?
          </h1>
          <p className="text-gray-600 text-lg text-center mb-8 leading-relaxed">
            Bij <span className="text-theme-purple font-semibold">RevOnc</span> zijn wij altijd op zoek naar nieuwe samenwerkingspartners om
            samen innovatieve oplossingen te ontwikkelen en patiënten beter te ondersteunen.
            Vul het formulier hieronder in en wij nemen contact met je op!
          </p>
        </Fade>

        {submitted ? (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-green-600 mb-4">Bedankt!</h2>
            <p className="text-gray-600">Je bericht is succesvol verzonden. We nemen spoedig contact met je op.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Naam */}
            <div>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Jouw naam"
                required
                className="w-full border p-2 rounded"
              />
            </div>

            {/* Bedrijfsnaam */}
            <div>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleInputChange}
                placeholder="Naam van je bedrijf"
                className="w-full border p-2 rounded"
              />
            </div>

            {/* Email */}
            <div>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Jouw e-mailadres"
                required
                className="w-full border p-2 rounded"
              />
            </div>

            {/* Telefoonnummer */}
            <div>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Jouw telefoonnummer"
                className="w-full border p-2 rounded"
              />
            </div>

            {/* Bericht */}
            <div>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Vertel ons waarom je wilt samenwerken"
                rows="5"
                required
                className="w-full border p-2 rounded"
              />
            </div>

            {/* Submit */}
            <div className="text-center">
              <Button
                type="submit"
                className="bg-theme-purple text-white px-6 py-3 rounded-lg hover:bg-dark-theme-purple transition duration-200"
              >
                Verstuur Bericht
              </Button>
            </div>
          </form>
        )}
      </div>
      <ToastContainer />
    </section>
  );
};
